<template>
    <div class="table-container">
        <p class="scroll-text">
            <span class="blink">横にスクロールできます →→→</span>
        </p>
        <div class="table-wrapper">
            <table class="vendor-table">
                <thead>
                    <tr>
                        <th class="header-cell fixed-column"></th>
                        <th class="header-cell vendor-column vendor-1">
                            <div class="ranking-badge no-1">
                                <span>No.1</span>
                            </div>
                            <div class="vendor-info">
                                <img src="../../assets/rank-table/vendor-1.png" alt="">
                                <p class="vendor-name">給湯器駆けつけ隊</p>
                            </div>
                        </th>
                        <th class="header-cell vendor-column vendor-2">
                            <div class="ranking-badge no-2">
                                <span>No.2</span>
                            </div>
                            <div class="vendor-info">
                                <img src="../../assets/rank-table/vendor-2.png" alt="">
                                <p class="vendor-name">キンライサー</p>
                            </div>
                        </th>
                        <th class="header-cell vendor-column vendor-3">
                            <div class="ranking-badge no-3">
                                <span>No.3</span>
                            </div>
                            <div class="vendor-info">
                                <img src="../../assets/rank-table/vendor-3.png" alt="">
                                <p class="vendor-name">街角給湯相談所</p>
                            </div>
                        </th>
                        <th class="header-cell vendor-column vendor-4">
                            <div class="ranking-badge no-4">
                                <span>No.4</span>
                            </div>
                            <div class="vendor-info">
                                <img src="../../assets/rank-table/vendor-4.png" alt="">
                                <p class="vendor-name">給湯パンダ</p>
                            </div>
                        </th>
                        <th class="header-cell vendor-column vendor-5">
                            <div class="ranking-badge no-5">
                                <span>No.5</span>
                            </div>
                            <div class="vendor-info">
                                <img src="../../assets/rank-table/vendor-5.png" alt="">
                                <p class="vendor-name">東京ガス</p>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th class="fixed-column">総合評価</th>
                        <td class="data-cell rank-1">
                            <span class="number"><span class="bold-red under-yellow">4.8</span></span>
                            <br>
                            <span class="hoshi">★★★★★</span>
                        </td>
                        <td class="data-cell">
                            <p>
                                <span class="number"><span class="bold-font">4.4</span></span>
                                <br>
                                <span class="normal">★★★★</span>
                            </p>
                        </td>
                        <td class="data-cell">
                            <span class="number"><span class="bold-font">4.0</span></span>
                            <br>
                            <span class="normal">★★★★</span>
                        </td>
                        <td class="data-cell">
                            <span class="number"><span class="bold-font">3.8</span></span>
                            <br>
                            <span class="normal">★★★★</span>
                        </td>
                        <td class="data-cell">
                            <span class="number"><span class="bold-font">3.5</span></span>
                            <br>
                            <span class="normal">★★★★</span>
                        </td>
                    </tr>
                    <tr>
                        <th class="fixed-column">特徴</th>
                        <td class="data-cell rank-1">
                            <p class="bold-red">業界最安値を保証<span class="annotation">※1</span></p>
                        </td>
                        <td class="data-cell">
                            <p class="bold-font">累計35万件の実績</p>
                        </td>
                        <td class="data-cell">
                            <p class="bold-font">商品割引率が高い</p>
                        </td>
                        <td class="data-cell">
                            <p class="bold-font">給湯器の種類が豊富</p>
                        </td>
                        <td class="data-cell">
                            <p class="bold-font">創業99年で安心</p>
                        </td>
                    </tr>
                    <tr>
                        <th class="fixed-column">本体最大割引</th>
                        <td class="data-cell rank-1">
                            <div class="double-circle"></div>
                            <p class="bold-font bold-red">最大91%OFF</p>
                        </td>
                        <td class="data-cell">
                            <div class="circle"></div>
                            <p class="bold-font">最大82%OFF</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">最大92%OFF</p>
                        </td>
                        <td class="data-cell">
                            <div class="triangle"></div>
                            <p class="bold-font">最大76%OFF</p>
                        </td>
                        <td class="data-cell">
                            <div class="circle"></div>
                            <p class="bold-font">最大80%OFF</p>
                        </td>
                    </tr>
                    <tr>
                        <th class="fixed-column">対応スピード</th>
                        <td class="data-cell rank-1">
                            <div class="double-circle"></div>
                            <p><span class="bold-font">即日対応OK</span><br>
                                <span class="bold-red">最短30分</span><span class="bold-font">で駆けつけ</span>
                            </p>
                        </td>
                        <td class="data-cell">
                            <div class="circle"></div>
                            <p class="bold-font">最短当日OK</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">即日対応OK<br>最短30分で駆けつけ</p>
                        </td>
                        <td class="data-cell">
                            <div class="circle"></div>
                            <p class="bold-font">最短当日OK</p>
                        </td>
                        <td class="data-cell">
                            <div class="circle"></div>
                            <p class="bold-font">最短当日OK</p>
                        </td>
                    </tr>
                    <tr>
                        <th class="fixed-column">保証</th>
                        <td class="data-cell rank-1">
                            <div class="double-circle"></div>
                            <p class="bold-red">商品・工事10年保証</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">商品・工事10年保証</p>
                        </td>
                        <td class="data-cell">
                            <div class="circle"></div>
                            <p class="bold-font">工事10年保証</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">商品・工事10年保証</p>
                        </td>
                        <td class="data-cell">
                            <div class="triangle"></div>
                            <p class="bold-font">保証なし</p>
                        </td>
                    </tr>
                    <tr>
                        <th class="fixed-column">ユーザー満足度</th>
                        <td class="data-cell rank-1">
                            <div class="double-circle"></div>
                            <p class="bold-red">お客様満足度97.3%<br>Google口コミ4.8</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">Google口コミ4.5</p>
                        </td>
                        <td class="data-cell">
                            <div class="triangle"></div>
                            <p class="bold-font">記載なし</p>
                        </td>
                        <td class="data-cell">
                            <div class="circle"></div>
                            <p class="bold-font">Google口コミ4.0</p>
                        </td>
                        <td class="data-cell">
                            <div class="triangle"></div>
                            <p class="bold-font">記載なし</p>
                        </td>
                    </tr>
                    <tr>
                        <th class="fixed-column">対応エリア</th>
                        <td class="data-cell rank-1">
                            <div class="double-circle"></div>
                            <p class="bold-font"><span class="bold-red">全国</span><br>※一部地域を除く</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">全国</p>
                        </td>
                        <td class="data-cell">
                            <div class="circle"></div>
                            <p class="bold-font">関東・関西<br>東海・中国</p>
                        </td>
                        <td class="data-cell">
                            <div class="circle"></div>
                            <p class="bold-font">一部エリアのみ</p>
                        </td>
                        <td class="data-cell">
                            <div class="circle"></div>
                            <p class="bold-font">東京都周辺</p>
                        </td>
                    </tr>
                    <tr>
                        <th class="fixed-column cta-cell">公式サイト</th>
                        <td class="data-cell rank-1" style="border-bottom: 2px solid red;">
                            <a :href="affiliateLink" target="_blank" rel="nofollow noopener" class="site-button red-button">
                                公式サイト
                            </a>
                        </td>
                        <td class="data-cell btn">
                            <a href="https://www.kyutooki.com/" target="_blank" class="site-button red-button">
                                公式サイト
                            </a>
                        </td>
                        <td class="data-cell btn">
                            <a href="https://lp.machikado-sodan.com/ab/XpBiwJMXRLixOgatw" target="_blank"
                                class="site-button red-button">
                                公式サイト
                            </a>
                        </td>
                        <td class="data-cell btn">
                            <a href="https://example.com" target="_blank" class="site-button red-button">
                                公式サイト
                            </a>
                        </td>
                        <td class="data-cell btn">
                            <a href="https://example.com" target="_blank" class="site-button red-button">
                                公式サイト
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="annotation-box">
                <p>
                    <span>※1 : 他社用の見積もりをご提示いただいた際に適用させていただく内容になっています。</span><br>
                    <span>※Google口コミ : {{ currentYear }}年{{ currentMonth }}月時点のGoogle評価</span><br>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { makeAffiliateUrl } from '@/utils/aff.js'
export default {
    name: 'vendorTable',
    data() {
        return {
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth() + 1
        };
    },
    computed: {
        affiliateLink() {
            return makeAffiliateUrl();
        }
    }
}
</script>

<style scoped>
.annotation-box {
    text-align: left;
    font-size: 10px;
    margin: 0;
    padding: 0;
    color: gray;
}

.annotation-box p {
    margin: 0;
    padding-left: 5px;
    padding-top: 5px;
}

.table-container {
    width: 100%;
    box-sizing: border-box;
}

.table-wrapper {
    overflow-x: auto;
    white-space: nowrap;
}

.vendor-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    border-spacing: 0;
    border: 1px solid #ccc;
    box-sizing: border-box;
    min-width: 800px;
}

.header-cell {
    background-color: #f0f8ff;
    border: 1px solid #ccc;
    font-weight: bold;
    vertical-align: top;
    padding: 5px;
}

.fixed-column {
    border-bottom: 1px solid #ccc;
    width: 100px;
    background-color: #848282;
    font-size: 14px;
    font-weight: bold;
    position: sticky;
    left: 0;
    z-index: 999;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
    color: #fff;
}

.vendor-column:not(.fixed-column) {
    width: 150px;
    vertical-align: top;
    position: relative;
    white-space: normal;
}

.data-cell:not(.fixed-column) {
    width: 150px;
}

.vendor-column.vendor-1 {
    background-color: #fffacd;
    border-left: 2px solid red;
    border-right: 2px solid red;
    border-top: 2px solid red;
}

.vendor-column.vendor-1 .ranking-badge {
    background-color: #ffc107;
}

.vendor-name {
    padding: 0;
    margin: 0;
}

.vendor-info p,
.vendor-info a {
    white-space: normal;
    word-break: break-all;
    font-size: 12px;
    text-align: center;
}

.vendor-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
}

.vendor-image {
    max-width: 100%;
    height: auto;
}

.data-cell {
    background-color: white;
    border: 1px solid #ccc;
    text-align: center;
    padding: 12px;
    vertical-align: middle;
    white-space: normal;
}

.vendor-table tbody tr>.data-cell:nth-child(2) {
    border-left: 2px solid red;
    border-right: 2px solid red;
}

.ranking-badge {
    padding: 0;
    margin: 0;
    color: #fff;
}

.rank-1 {
    background-color: #fffacd;
}

.ranking-badge.no-1 {
    background-color: #ff8c00;
}

.ranking-badge.no-2 {
    background-color: #aba4a4;
}

.ranking-badge.no-3 {
    background-color: #a0522d;
}

.ranking-badge.no-4 {
    background-color: #d4855f;
}

.ranking-badge.no-5 {
    background-color: #e4bdaa;
}

.data-cell p {
    margin-top: 3px;
    margin-bottom: 0;
}

.gray-triangle {
    display: inline-block;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 20px solid #777;
}

.site-button {
    background-color: #d9534f;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-weight: bold;
    text-decoration: none;
    margin: 6px 0;
}

.btn {
    padding: 20px;
}

td {
    font-weight: 600;
}

.hoshi {
    color: #ebd515;
    font-size: 20px;
}

.normal {
    font-size: 20px;
}

.number {
    font-weight: bold;
    font-size: 20px;
}

.point {
    font-weight: 700;
    font-size: 15px;
}

.vendor-info img {
    width: 100%;
    padding-top: 10px;
}

.scroll-text {
    padding-right: 10px;
    margin: 0;
    text-align: right;
    font-size: 18px;
    background: #eef5ff;
}

@keyframes blinking {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.blink {
    animation: blinking 1s ease-in-out infinite alternate;
}

td {
    font-size: 14px;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    .vendor-column:not(.fixed-column) {
        width: 150px;
    }

    .data-cell:not(.fixed-column) {
        width: 150px;
        padding: 6px;
    }

    .fixed-column {
        font-size: 0.9rem;
        width: 100px;
    }

    .ranking-badge span {
        font-size: 1.2rem;
    }

    .vendor-info p {
        font-size: 0.8rem;
    }

    .annotation-box p {
        font-size: 0.7rem;
    }

    .scroll-text {
        font-size: 1.2rem;
    }

    .number span,
    .hoshi,
    .normal {
        font-size: 1.1rem;
    }

    .number span {
        font-size: 1.3rem;
    }

    .cta-cell {
        padding: 15px;
    }

    .scroll-text {
        font-size: 1rem;
    }
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 480px) {
    .vendor-column:not(.fixed-column) {
        width: 140px;
        font-size: 0.8rem;
    }

    .data-cell:not(.fixed-column) {
        width: 140px;
        padding: 6px;
        font-size: 0.9rem;
    }

    .fixed-column {
        font-size: 0.9rem;
        width: 100px;
    }

    .ranking-badge span {
        font-size: 1rem;
    }

    .vendor-info p {
        font-size: 0.8rem;
    }

    .annotation-box p {
        font-size: 0.7rem;
    }

    .number span,
    .hoshi,
    .normal {
        font-size: 1.2rem;
    }

    .number span {
        font-size: 1.5rem;
    }

    .cta-cell {
        padding: 15px;
    }

    .scroll-text {
        font-size: 1rem;
        padding-top: 10px;
    }
}
</style>
